import { render, staticRenderFns } from "./DeepInfo.vue?vue&type=template&id=08034658&scoped=true&"
import script from "./DeepInfo.vue?vue&type=script&lang=js&"
export * from "./DeepInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeepInfo.vue?vue&type=style&index=0&id=08034658&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08034658",
  null
  
)

export default component.exports